<template>
  <form v-on:submit="save">
    <div class="card card-info" v-if="grid === 'hide'">
      <div class="card-header with-border">
        <h3 class="card-title">Aggregate Setup</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <label>Session *</label>
            <select required class="form-control" v-model="AggregateSetup.ActiveSemesterID" v-on:change="loadProgram()">
              <option value="" selected="selected" disabled="disabled">--Select Semester--</option>
              <option v-for="item in semesters" v-bind:value="item.SemesterID">{{item.Name}}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label>Program *</label>
            <select required class="form-control" v-model="AggregateSetup.ProgramId">
              <option value="" selected="selected" disabled="disabled">--Select Program--</option>
              <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
            </select>
          </div>
        </div>
        <div class="row" style="margin-top: 10px">
          <div class="col-md-12">
            <label>Description</label>
            <input class="form-control" v-model="AggregateSetup.Description" maxlength="60" />
          </div>
        </div>
        <div class="row" style="margin-top: 10px;">
          <div class="col-md-6">
            <table class="table table-bordered table-sm">
              <thead class="bg-info">
                <tr>
                  <th width="5%">Sr.</th>
                  <th width="75%">Aggregate Type</th>
                  <th width="20%">%</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in AggregateTypes">
                  <td>{{ind+1}}</td>
                  <td>{{item.Name}}</td>
                  <td>
                    <input type="tel" v-mask="'###'" class="form-control" v-model="item.Percentage" v-on:change="calculatePercentage()" />
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="2">Total</th>
                  <td>
                    <input disabled="disabled" class="form-control" v-model="total" />
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div class="card-footer" style="text-align: right">
        <input type="submit" value="Save" class="btn btn-success float-right" />
        <button type="button" class="btn btn-danger float-left" v-on:click="Cancel()">Cancel</button>
      </div>
    </div>
    <div class="card card-info" v-if="grid === 'show'">
      <div class="card-header">
        <h3 class="card-title" style="width: 100%">
          <button v-on:click="AddNew()" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
        </h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive">
              <table id="table" class="table table-bordered table-sm text-sm" width="100%">
                <thead class="bg-info">
                  <tr>
                    <th align="center">Session</th>
                    <th align="center">Program</th>
                    <th align="center">Description</th>
                    <th align="center">Date</th>
                    <th align="center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in Aggregate">
                    <td>{{item.Semester}}</td>
                    <td>{{item.Program}}</td>
                    <td>{{item.Description}}</td>
                    <td align="center">{{item.Date}}</td>
                    <td align="center"> <i class="fa fa-2x fa-edit" v-on:click="edit(item.AggregateSetupID)"></i></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>

  const axios = require('axios').default;

  export default ({

    data() {
      return {
        AggregateTypes: [],
        semesters: [],
        departments: [],
        programs: [],
        AggregateSetup: {
          Description: '',
          ActiveSemesterID: '',
          DepartmentID: '',
          ProgramId: '',
        },
        total: 0,
        grid: 'show',
        Aggregate: [],
      }
    },

    mounted: function () {
      this.pageload();
    },

    updated: function () {
    },

    methods:
    {
      pageload() {
        startReq();
        var vm = this;
        axios.get('/api/AdmissionApi/pageLoadAggregateSetup')
          .then(function (res) {
            endReq();
            vm.semesters = res.data.sem;
            vm.AggregateTypes = res.data.aggtyp;
            vm.Aggregate = res.data.agg;
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      AddNew() {
        this.grid = 'hide';
      },

      loadProgram() {
        startReq();
        var vm = this;
        axios.get('/api/admissionapi/loadOfferedProgramSemesterWise?semID=' + vm.AggregateSetup.ActiveSemesterID)
          .then(function (res) {
            endReq();
            vm.programs = res.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      save(e) {
        e.preventDefault();
        if (this.total == 100) {
          startReq();
          var vm = this;
          axios.post('/api/AdmissionApi/SaveAggregate', {
            AggregateSetup: vm.AggregateSetup,
            AggregateTypes: vm.AggregateTypes
          })
            .then(function (res) {
              endReq();
              if (res.data.status) {
                toastr.success(res.data.msg);
                vm.clear();
              }
              else {
                toastr.error(res.data.msg);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        }
        else {
          toastr.error("Total Must be equal to 100");
        }
      },

      calculatePercentage() {
        this.total = 0;
        for (var i = 0; i < this.AggregateTypes.length; i++) {
          this.total += Number(this.AggregateTypes[i].Percentage);
        }
      },

      edit(ID) {
        startReq();
        var vm = this;
        axios.get('/api/admissionapi/editAggregateSetup?AggSetupID=' + ID)
          .then(function (res) {
            endReq();
            vm.programs = res.data.prog;
            vm.AggregateSetup.AggregateSetupID = res.data.lst.AggregateSetupID;
            vm.AggregateSetup.Description = res.data.lst.Description;
            vm.AggregateSetup.ActiveSemesterID = res.data.lst.ActiveSemesterID;
            vm.AggregateSetup.ProgramId = res.data.lst.ProgramId;
            vm.AggregateTypes = res.data.lst.AggregateChild;
            vm.grid = 'hide';
            vm.total = 100;
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      Cancel() {
        location.reload();
      },

      clear() {
        this.AggregateSetup = {
          Description: '',
          ActiveSemesterID: '',
          DepartmentID: '',
          ProgramId: '',
        };
        this.programs = [];
        this.total = 0;
        this.AggregateTypes.forEach(function (item) {
          item.Percentage = 0;
        });
      }

    }

  });
</script>



// WEBPACK FOOTER //
// src/components/onlineadmission/aggregateSetup.vue